module.exports = __webpack_public_path__ + "15fc3a0ed347c79721c1c8fc33968419.svg";